interface MetaEnvironment extends ImportMetaEnv {
  VITE_GOOGLE_API_KEY: string
  VITE_FIREBASE_API_KEY: string
  VITE_FIREBASE_AUTH_DOMAIN: string
  VITE_FIREBASE_PROJECT_ID: string
  VITE_FIREBASE_STORAGE_BUCKET: string
  VITE_FIREBASE_SENDER_ID: string
  VITE_FIREBASE_APP_ID: string
  VITE_FIREBASE_MEASUREMENT_ID: string
  VITE_LAUNCH_DARKLY_SDK_CLIENT: string
  VITE_CLARITY_PROJECT_ID: string
  VITE_CLEVERTAP_ACCOUNT_ID: string
  VITE_ENVIRONMENT: 'staging' | 'preprod' | 'production' | 'development'
}

const {
  VITE_GOOGLE_API_KEY: GOOGLE_API_KEY,
  VITE_LAUNCH_DARKLY_SDK_CLIENT: LAUNCH_DARKLY_SDK_CLIENT,
  VITE_ENVIRONMENT: ENVIRONMENT,
  VITE_FIREBASE_API_KEY: FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID: FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_SENDER_ID: FIREBASE_SENDER_ID,
  VITE_FIREBASE_APP_ID: FIREBASE_APP_ID,
  VITE_FIREBASE_MEASUREMENT_ID: FIREBASE_MEASUREMENT_ID,
  VITE_CLARITY_PROJECT_ID: CLARITY_PROJECT_ID,
  VITE_CLEVERTAP_ACCOUNT_ID: CLEVERTAP_ACCOUNT_ID
} = import.meta.env as MetaEnvironment

export {
  CLARITY_PROJECT_ID,
  CLEVERTAP_ACCOUNT_ID,
  ENVIRONMENT,
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_PROJECT_ID,
  FIREBASE_SENDER_ID,
  FIREBASE_STORAGE_BUCKET,
  GOOGLE_API_KEY,
  LAUNCH_DARKLY_SDK_CLIENT
}
